import { usePathname, useRouter } from "@shared/client/navigation";
import { useTransition } from "react";
import { CalendarRange } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/components/ui/select";

/** Fenêtre d'observation d'un écran de contrôle — un filtre, en haut, sur une ligne. */
export function PeriodSelect({
  days,
  options,
}: {
  days: number;
  options: Array<{ days: number; label: string }>;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const [pending, startTransition] = useTransition();

  return (
    <Select
      disabled={pending}
      onValueChange={(value) => startTransition(() => router.push(`${pathname}?days=${value}`))}
      value={String(days)}
    >
      <SelectTrigger aria-label="Période" className="h-8 gap-2 text-xs font-semibold" size="sm">
        <CalendarRange aria-hidden="true" className="text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.days} value={String(option.days)}>{option.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
